// extracted by mini-css-extract-plugin
export var primitiveLabel = "_vk-0";